import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({
    easing: "ease", // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
});
Vue.use(VueRouter)

//引入注册
import Login from '@/views/login/login.vue'
import ContainerView from '@/layout/ContainerView.vue'
import decisionMain from '@/views/decisionPage/decisionMain.vue'
const routes = [
    //登录
    {
        path: '/login',
        name: '登录页',
        component: Login,
    },
    {
        path: '/decisionMain',
        name: '流程图（临时）',
        component: decisionMain,
    },
    // 入录入详情
    {
      path: '/enterManage/enteryDetailPage',
      name: '入录入详情',
      component: () => import('@/views/enterManage/enteryDetailPage.vue'),
    },
    // {
    //   path: '*',
    //   name: '404',
    //   component: () => import('@/pages/exception/404'),
    // },
    // {
    //   path: '/403',
    //   name: '403',
    //   component: () => import('@/pages/exception/403'),
    // },
    {
        path: '/',
        name: '首页',
        component: ContainerView,
        redirect: '/login',
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/HomePage/home.vue'),
            },
            {
                path: '/patientGroup',
                name: '病人分组',
                component: () => import('@/views/PatientManage/patientGroup.vue'),
            },
            {
                path: '/groupDetails',
                name: '分组详情',
                component: () => import('@/views/PatientManage/groupDetails.vue'),
            },
            {
                path: '/groupList',
                name: '分组列表',
                component: () => import('@/views/PatientManage/groupList.vue'),
            },
            {
                path: '/messageTem',
                name: '消息模板',
                component: () => import('@/views/PatientManage/messageTem.vue'),
            },
            {
                path: '/patientHistory',
                name: '历史记录',
                component: () => import('@/views/PatientManage/patientHistory.vue'),
            },
            {
                path: '/patientdetails',
                name: '人档病案',
                component: () => import('@/views/PatientManage/patientdetails.vue'),
            },
            {
                path: '/patientmanage',
                name: 'Patientmanage',//（病人管理）
                component: () => import('@/views/newPatientmanage/src/index/index.vue'),
            },
            {
                path: '/patientmanage/detail',
                name: '病人管理详情',
                component: () => import('@/views/newPatientmanage/src/index/patientManageDetail.vue'),
            },
            {
                path: '/indexHzDetail',
                name: 'indexHzDetail',
                component: () => import('@/views/newPatientmanage/src/index/indexHzDetail.vue'),
            },
            {
                path: '/indexHz',
                name: 'indexHz',
                component: () => import('@/views/newPatientmanage/src/index/indexHz.vue'),
            },
            {
                meta: {
                    name: '宣教内容管理',
                },
                path: '/ToolMaintenance/tool',
                component: () => import('@/views/ToolMaintenance/tool.vue'),
            },
            {
                meta: {
                    name: '推荐症状维护',
                },
                path: '/ToolMaintenance/suggestSymptom',
                component: () => import('@/views/ToolMaintenance/suggestSymptom/index.vue'),
            },
            {
                meta: {
                    name: '推荐症状维护',
                },
                path: '/ToolMaintenance/symptomDetail',
                component: () => import('@/views/ToolMaintenance/suggestSymptom/symptomDetail/index.vue'),
            },
            {
                meta: {
                    name: '同义词维护',
                },
                path: '/ToolMaintenance/synonym',
                component: () => import('@/views/ToolMaintenance/synonym/index.vue'),
            },
            {
                meta: {
                    name: '宣教内容详情',
                },
                path: '/ToolMaintenance/tooldetail',
                component: () => import('@/views/ToolMaintenance/ToolDetail.vue'),
            },
            // {
            //   meta: {
            //     name: '问题问卷管理',
            //   },
            //   path: '/ToolMaintenance/problem',
            //   component: () => import('@/views/ToolMaintenance/problem.vue'),
            // },
            {
                meta: {
                    name: '评估量表管理',
                },
                path: '/ToolMaintenance/assessment',
                component: () => import('@/views/ToolMaintenance/assessment.vue'),
            },
            {
                meta: {
                    name: '培训教程管理',
                },
                path: '/ToolMaintenance/reain',
                component: () => import('@/views/ToolMaintenance/reain.vue'),
            },
            {
                meta: {
                    name: '培训教程管理2',
                    keepAlive: true,
                    isBack: false
                },
                name: 'courseList',
                path: '/ToolMaintenance/courseList',
                component: () => import('@/views/ToolMaintenance/courseList.vue'),
            },
            {
                meta: {
                    name: '培训教程管理详情',
                    // keepAlive: true // 该路由会被缓存
                },
                path: '/ToolMaintenance/reainDetail',
                component: () => import('@/views/ToolMaintenance/ReainDetail.vue'),
            },
            {
                meta: {
                    name: '报告反馈配置',
                },
                path: '/ToolMaintenance/ReportFeedbackConfig',
                component: () => import('@/views/ToolMaintenance/ReportFeedbackConfig.vue'),
            },
            {
                meta: {
                    name: '全病程订单',
                },
                path: '/OrderManagement/order',
                component: () => import('@/views/OrderManagement/order.vue'),
            },
            {
                meta: {
                    name: '协同订单',
                },
                path: '/OrderManagement/cooperate',
                component: () => import('@/views/OrderManagement/cooperate.vue'),
            }, 
            {
                meta: {
                    name: '问诊订单',
                },
                path: '/OrderManagement/interrogation',
                component: () => import('@/views/OrderManagement/interrogation.vue'),
            },
            {
                meta: {
                    name: '电子处方',
                },
                path: '/OrderManagement/prescription',
                component: () => import('@/views/OrderManagement/prescription.vue'),
            },
            {
                meta: {
                    name: '药品订单',
                },
                path: '/OrderManagement/drugs',
                component: () => import('@/views/OrderManagement/drugs.vue'),
            },
            {
                meta: {
                    name: '医护上门订单',
                },
                path: '/OrderManagement/doctorOrder',
                component: () => import('@/views/OrderManagement/doctorOrder.vue'),
            },
            {
                meta: {
                    name: '订单汇总记录'
                },
                path: '/OrderManagement/orderAllRecord',
                component: () => import('@/views/OrderManagement/orderSummaryRecord.vue')
            },
            {
                meta: {
                    name: '商品支付订单'
                },
                path: '/OrderManagement/OrderCommodityPay',
                component: () => import('@/views/OrderManagement/OrderCommodityPay/index.vue')
            },
            {
                meta: {
                    name: '审方管理',
                },
                path: '/AuditorManagement/auditor',
                component: () => import('@/views/AuditorManagement/auditor.vue'),
            },
            {
                meta: {
                    name: '客服管理',
                },
                path: '/customer',
                component: () => import('@/views/CustomerService/customer.vue'),
            },
            {
                meta: {
                    name: '自动回复',
                    flag: true
                },
                path: '/autoreply',
                component: () => import('@/views/CustomerService/autoreply.vue'),
            },
            {
                meta: {
                    name: '添加回复',
                    flag: true
                },
                path: '/addreply',
                component: () => import('@/views/CustomerService/addreply.vue'),
            },
            {
                name: '医院信息',
                path: '/Organization/organization',
                component: () => import('@/views/Organization/organization.vue'),
            },
            {
                name: '平台信息',
                path: '/Organization/platforminform',
                component: () => import('@/views/Organization/platforminform/index.vue'),
            },
            {
                name: '医护资质审核',
                path: '/Organization/medicalQualificationCheck',
                component: () => import('@/views/Organization/medicalQualificationCheck.vue'),
            },
            {
                name: '科室管理',
                path: '/Organization/departmentManage',
                component: () => import('@/views/Organization/departmentManage.vue'),
            },
            {
                name: '机构管理',
                path: '/Organization/institutionManage',
                component: () => import('@/views/Organization/institutionManage.vue'),
            },
            {
                name: '机构信息',
                path: '/Organization/InstitutionInfo',
                component: () => import('@/views/Organization/InstitutionInfo.vue'),
            },
            {
                name: '新增机构',
                path: '/Organization/addInstitution',
                component: () => import('@/views/Organization/addInstitution.vue'),
            },
            {
                name: '编辑机构',
                path: '/Organization/updateInstitution',
                component: () => import('@/views/Organization/updateInstitution.vue'),
            },
            {
                name: '开放科室',
                path: '/Organization/department',
                component: () => import('@/views/Organization/department.vue'),
            },
            {
                name: '医护信息',
                path: '/Organization/medicalinfo',
                component: () => import('@/views/Organization/medicalinfo.vue'),
            },
            {
                name: '科室主页',
                path: '/Organization/departmentHomePage',
                component: () => import('@/views/Organization/departmentHomePage/departmentHomePage.vue'),
            },
            {
                name: '科室主页编辑',
                path: '/Organization/departmentHomePage/configDepartmentPage',
                component: () => import('@/views/Organization/departmentHomePage/components/configDepartmentPage.vue'),
            },
            {
                name: '新增医护信息',
                path: '/Organization/addMedicalinfo',
                component: () => import('@/views/Organization/addMedicalinfo.vue'),
            },
            {
                name: '编辑医护信息',
                path: '/Organization/updateMedicalinfo',
                component: () => import('@/views/Organization/updateMedicalinfo.vue'),
            },
            {
                name: '新增医护团队',
                path: '/Organization/addMedicalteam',
                component: () => import('@/views/Organization/addMedicalteam.vue'),
            },
            {
                name: '编辑医护团队',
                path: '/Organization/updateMedicalteam',
                component: () => import('@/views/Organization/updateMedicalteam.vue'),
            },
            {
                name: '疗管团队',
                path: '/Organization/TreatmentManagementTeam',
                component: () => import('@/views/Organization/TreatmentManagementTeam.vue'),
            },

            {
                name: '资质审核',
                path: '/Organization/examine',
                component: () => import('@/views/Organization/examine.vue'),
            },
            {
                name: '医护团队',
                path: '/Organization/medicalteam',
                component: () => import('@/views/Organization/medicalteam.vue'),
            },
            {
                name: '意见反馈',
                path: '/Organization/feedback',
                component: () => import('@/views/Organization/feedback.vue'),
            },
            {
                name: '互医机构',
                path: '/Organization/medicalmutual',
                component: () => import('@/views/Organization/medicalmutual.vue'),
            },
            {
                name: '新增互医机构',
                path: '/addmedicalmutual',
                component: () => import('@/views/Organization/addmedicalmutual.vue'),
            },
            {
                name: '用户列表',
                path: '/SystemSettings/settings',
                component: () => import('@/views/SystemSettings/settings.vue'),
            },
            {
                name: '内容栏目管理',
                path: '/SystemSettings/contentColumnManagement',
                component: () => import('@/views/SystemSettings/contentColumnManagement.vue'),
            },
            // {
            //   name: 'app操作教程',
            //   path: '/SystemSettings/appOperateCourse',
            //   component: () => import('@/views/SystemSettings/appOperateCourse.vue'),
            // },
            {
              name: 'app操作教程',
              path: '/SystemSettings/appOperateCourse',
              component: () => import('@/views/SystemSettings/appOperateCourse.vue'),
            },
            {
                name: '角色列表',
                path: '/SystemSettings/rolelist',
                component: () => import('@/views/SystemSettings/rolelist.vue'),
            },
            {
                name: '菜单列表',
                path: '/SystemSettings/menulist',
                component: () => import('@/views/SystemSettings/menulist.vue'),
            },
            {
                name: '部门管理',
                path: '/SystemSettings/resourcelist',
                component: () => import('@/views/SystemSettings/resourcelist.vue'),
            },
            {
                name: '日志管理',
                path: '/SystemSettings/logmanage',
                component: () => import('@/views/SystemSettings/logmanage.vue'),
            },
            {
                name: '版本管理',
                path: '/SystemSettings/versions',
                component: () => import('@/views/SystemSettings/versions.vue'),
            },
            {
                name: '标签管理',
                path: '/SystemSettings/LabelManage',
                component: () => import('@/views/SystemSettings/LabelManage/index.vue'),
            },
            {
                name: '病种信息配置',
                path: '/SystemSettings/Biochemistry',
                component: () => import('@/views/SystemSettings/Biochemistry/index.vue'),
            },
            {
                name: '用户协议管理',
                path: '/SystemSettings/UserAgreement',
                component: () => import('@/views/SystemSettings/UserAgreement.vue'),
            },
            {
                name: '/SystemSettings/newsSetting',
                path: '/SystemSettings/newsSetting',
                component: () => import('@/views/SystemSettings/newsSetting.vue'),
            },
            {
                name: '新增资讯',
                path: '/SystemSettings/newsSetting/addNews',
                component: () => import('@/views/SystemSettings/addNews.vue'),
            },
            {
                name: '视频素材管理',
                path: '/SystemSettings/videoMateria',
                component: () => import('@/views/SystemSettings/videoMateria.vue'),
            },
            {
                name: '资料配置',
                path: '/Organization/dataConfigurationAddEdit',
                component: () => import('@/views/Organization/dataConfigurationAddEdit.vue'),
            },
            {
                name: '资料配置列表',
                path: '/Organization/dataConfigurationList',
                component: () => import('@/views/Organization/dataConfigurationList.vue'),
            },
            {
                name: '数据看板',
                path: '/dataBoard',
                component: () => import('@/views/HomePage/dataBoard.vue'),
            },
        ],
    },
    {
        name: '标准数据库',
        path: '/standardDatabase',
        redirect: '/standardDatabase/case-1',
        component: ContainerView,
        children: [
            {
                path: '/standardDatabase/case-1',
                name: '西药药品',
                component: () => import('@/views/StandardDatabase/src/case-1/drug.vue'),
            },
            {
                path: '/standardDatabase/case-2',
                name: '检验',
                component: () => import('@/views/StandardDatabase/src/case-2/index.vue'),
            },
            {
                path: '/standardDatabase/case-3',
                name: '检查',
                component: () => import('@/views/StandardDatabase/src/case-3/index.vue'),
            },
            {
                path: '/standardDatabase/case-4',
                name: '治疗',
                component: () => import('@/views/StandardDatabase/src/case-4/index.vue'),
            },
            {
                path: '/standardDatabase/case-5',
                name: '科研代码管理',
                component: () => import('@/views/StandardDatabase/src/case-5/index.vue'),
            },
            {
                name: '运动处方库',
                path: '/standardDatabase/case-6',
                component: () => import('@/views/StandardDatabase/src/case-6/PrescriptionLibrary/src/index/index.vue'),
            },
            {
                name: '食材库',
                path: '/standardDatabase/case-7',
                component: () => import('@/views/StandardDatabase/src/case-7/index.vue'),
            },
            {
                name: '宣教库',
                path: '/standardDatabase/case-8',
                component: () => import('@/views/StandardDatabase/src/case-8/index.vue'),
            },
            {
                name: '菜肴库',
                path: '/standardDatabase/case-9',
                component: () => import('@/views/StandardDatabase/src/case-9/index.vue'),
            },
            {
                name: '药品不良反应数据库',
                path: '/standardDatabase/case-10',
                component: () => import('@/views/StandardDatabase/src/case-10/index.vue'),
            },
            {
                name: '不良反应',
                path: '/standardDatabase/adverseReaction',
                component: () => import('@/views/StandardDatabase/src/adverseReaction/adverseReaction.vue'),
            },
            {
                name: '患者常见问题库',
                path: '/standardDatabase/patientQuestion',
                component: () => import('@/views/StandardDatabase/src/patientQuestion/patientQuestion.vue'),
            },
            {
                name: '症状',
                path: '/standardDatabase/symptom',
                component: () => import('@/views/StandardDatabase/src/symptom/index.vue'),
            },
        ],
    },
    {
        name: '问题问卷管理',
        path: '/question',
        component: ContainerView,
        children: [
            {
                name: 'questionManager',
                path: '/questionManager',
                component: () => import('@/views/questionnaire/src/index/index.vue'),
                meta: {
                    title: '问题问卷管理',
                },
            },
            {
                name: 'addQuestion',
                path: '/addQuestion',
                component: () => import('@/views/questionnaire/src/addQuestion/index.vue'),
                meta: {
                    name: '问卷问卷新增',
                },
            }
        ]
    },
    {
        name: '新版问题问卷管理',
        path: '/ToolMaintenance/questionnaireManage',
        component: ContainerView,
        children: [
            {
                name: 'questionnaireManage',
                path: '/ToolMaintenance/questionnaireManage',
                component: () => import('@/views/ToolMaintenance/questionnaireManage.vue'),
                meta: {
                    title: '问题问卷管理',
                },
            },
            {
                name: 'addQuestionnaire',
                path: '/ToolMaintenance/addQuestionnaire',
                component: () => import('@/views/ToolMaintenance/addQuestionnaire.vue'),
                meta: {
                    name: '新增问卷',
                },
            }
        ]
    },
    {
        name: '新版问卷管理',
        path: '/ToolMaintenance/newVersionQuestionnaire',
        component: ContainerView,
        children: [
            {
                name: 'newVersionQuestionnaire',
                path: '/ToolMaintenance/newVersionQuestionnaire',
                component: () => import('@/views/ToolMaintenance/newVersionQuestionnaire.vue'),
                meta: {
                    title: '新版问卷管理',
                },
            }
        ]
    },
    {
        name: '健康工具测评配置',
        path: '/ToolMaintenance/healthToolCheckConfig',
        component: ContainerView,
        children: [
            {
                name: 'healthToolCheckConfig',
                path: '/ToolMaintenance/healthToolCheckConfig',
                component: () => import('@/views/ToolMaintenance/healthToolCheckConfig.vue'),
                meta: {
                    title: '健康工具测评配置',
                },
            }
        ]
    },
    {
        name: '关键康复工具配置',
        path: '/ToolMaintenance/rehabilitationTools',
        component: ContainerView,
        children: [
            {
                name: 'rehabilitationTools',
                path: '/ToolMaintenance/rehabilitationTools',
                component: () => import('@/views/ToolMaintenance/rehabilitationTools.vue'),
                meta: {
                    title: '关键康复工具配置',
                },
            }
        ]
    },

    {
        name: '医护上门管理',
        path: '/doctorSnurses',
        component: ContainerView,
        children: [
            {
                name: 'exceptionHandling',
                path: '/doctorSnurses/case-1',
                component: () => import('@/views/DoctorSnurses/src/case-1/index.vue'),
                meta: {
                    title: '异常情况处理',
                },
            },
            {
                name: 'serviceOrder',
                path: '/doctorSnurses/case-2',
                component: () => import('@/views/DoctorSnurses/src/case-2/index.vue'),
                meta: {
                    name: '服务订单管理',
                },
            },
            {
                name: 'serviceOrderConfig',
                path: '/doctorSnurses/case-3',
                component: () => import('@/views/DoctorSnurses/src/case-3/index.vue'),
                meta: {
                    name: '服务订单配置',
                },
            },
            {
                name: 'customerMessage',
                path: '/doctorSnurses/case-4',
                component: () => import('@/views/DoctorSnurses/src/case-4/index.vue'),
                meta: {
                    name: '客服消息管理',
                },
            }
        ]
    },

    {
        path: '/treatment',
        name: '疗程管理',
        component: ContainerView,
        children: [
            {
                path: '/case',
                name: 'IntoTheCase',
                component: () => import('@/views/treatment/src/case-1/index.vue'),
                meta: {
                    title: '入案管理',
                    num: 1,//数字角标
                    icon: 'icon',//图标
                    btnPermissions: ['admin', 'supper'], //页面需要的权限
                    invisible: false,//是否不将此路由项渲染为菜单项，默认false；如设置为 true，则生成菜单时将忽略此路由
                }
            }, 
            {
              path: '/case-7',
              name: '不良事件',
              component: () => import('@/views/treatment/src/case-7/index.vue'),
            }, 
            {
                path: '/customerRoom',
                name: 'customerRoom',
                component: () => import('@/views/treatment/src/case-1/consultRoom.vue'),
                meta: {
                    title: '客服咨询'
                }
            } 
        ]
    },

    {
        path: '/scoentific',
        name: '科研',
        component: ContainerView,
        children: [
            {
                path: '/scoentificCas-1',
                name: '已申请科研管理',
                component: () => import('@/views/scoentific/src/case-1/index.vue'),
            },
            {
                path: '/scoentificCas-2',
                name: '已申请科研团队管理',
                component: () => import('@/views/scoentific/src/case-2/index.vue'),
            },
            {
                path: '/scoentificCas-3',
                name: '科研日历管理',
                component: () => import('@/views/scoentific/src/case-3/index.vue'),
            },
            {
                path: '/scoentificCas-4',
                name: '展示内容编辑',
                component: () => import('@/views/scoentific/src/case-4/index.vue'),
            },
            {
                path: '/scoentificCas-5',
                name: '科研队列数据汇总',
                component: () => import('@/views/scoentific/src/case-5/index.vue'),
            },
        ]
    },
    {
        path: '/Chaining',
        name: '新编链',
        component: ContainerView,
        children: [
            {
                path: '/Chaining/case-1',
                name: '医生链',
                component: () => import('@/views/chaining/src/case-1/index.vue'),
            },
            {
                path: '/Chaining/case-2',
                name: '患者链',
                component: () => import('@/views/chaining/src/case-2/index.vue'),
            },
            {
                path: '/Chaining/case-3',
                name: '模板链',
                component: () => import('@/views/chaining/src/case-3/index.vue'),
            },
            {
                path: '/Chaining/case-4',
                name: '模板链审核',
                component: () => import('@/views/chaining/src/case-4/index.vue'),
            },
            {
                path: '/Chaining/case-5',
                name: '编链模块一',
                component: () => import('@/views/chaining/index.vue'),
            },
            {
                path: '/Chaining/case-6',
                name: '方案详情',
                component: () => import('@/views/chaining/src/case-5/index.vue'),
            },
            {
                path: '/Chaining/case-6/call-template',
                name: '调用模板链1',
                component: () => import('@/views/chaining/components/CallTemplate/index.vue'),
            },
        ]
    },
    {
        path: '/decisionPage',
        name: '决策设置',
        component: ContainerView,
        children: [
            {
                path: '/decisionPage/templatePage',
                name: '模板编辑',
                component: () => import('@/views/decisionPage/templatePage.vue'),
            },
            {
                path: '/decisionPage/classificationSettings',
                name: '分类设置',
                component: () => import('@/views/decisionPage/classificationSettings.vue'),
            },
            {
                path: '/decisionPage/TemplateSettings',
                name: '模板设置',
                component: () => import('@/views/decisionPage/TemplateSettings.vue'),
            },
            {
                path: '/decisionPage/patientPage',
                name: '患者编辑',
                component: () => import('@/views/decisionPage/patientPage.vue'),
            },
            {
                path: '/decisionPage/templateApproval',
                name: '模板审核',
                component: () => import('@/views/decisionPage/templateApproval.vue'),
            },
        ]
    },
    {
        path: '/enterManage',
        name: '录入管理',
        component: ContainerView,
        children: [
            {
                path: '/enterManage/enterList',
                name: '入录列表',
                component: () => import('@/views/enterManage/enterList.vue'),
            },
            {
                path: '/enterManage/myEntery',
                name: '我的入录',
                component: () => import('@/views/enterManage/myEntery.vue'),
            },
            // // 入录入详情
            // {
            //   path: '/enterManage/enteryDetailPage',
            //   name: '入录入详情',
            //   component: () => import('@/views/enterManage/enteryDetailPage.vue'),
            // }
        ]
    },
    {
        path: '/scoentificTool',
        name: '科研工具',
        component: ContainerView,
        children: [
            {
                path: '/scoentificTool/article',
                name: '文章精选',
                component: () => import('@/views/scoentificTool/article.vue'),
            },
            {
                path: '/scoentificTool/calenderProject',
                name: '科研项目',
                component: () => import('@/views/scoentificTool/calenderProject.vue'),
            },
            {
                path: '/scoentificTool/calenderMeeting',
                name: '学术会议',
                component: () => import('@/views/scoentificTool/calenderMeeting.vue'),
            },
            {
                path: '/scoentificTool/calenderMy',
                name: '用户自建',
                component: () => import('@/views/scoentificTool/calenderMy.vue'),
            },
            {
                path: '/scoentificTool/tips',
                name: '科研tips管理',
                component: () => import('@/views/scoentificTool/tips.vue'),
            },
            {
                path: '/scoentificTool/statistics',
                name: '统计管理',
                component: () => import('@/views/scoentificTool/statistics.vue'),
            }
        ]
    },
    {
        path: '/termPage',
        name: '运营管理',
        component: ContainerView,
        children: [
            {
                path: '/termPage/termList',
                name: '新增术语',
                component: () => import('@/views/termPage/termList.vue'),
            },
            {
                path: '/termPage/outerChain',
                name: '外链链接',
                component: () => import('@/views/termPage/outerChain.vue'),
            },
            {
                path: '/termPage/addOuterChain',
                name: '外链链接',
                component: () => import('@/views/termPage/addOuterChain.vue'),
            },
            {
                path: '/termPage/updateOuterChain',
                name: '外链链接',
                component: () => import('@/views/termPage/updateOuterChain.vue'),
            },
            {
                path: '/termPage/shareCode',
                name: '小程序分享',
                component: () => import('@/views/termPage/shareCode.vue'),
            },
            {
                path: '/termPage/medicalInquirie',
                name: '在线问诊',
                component: () => import('@/views/termPage/medicalInquirie/medicalInquirie.vue'),
            },
            {
                path: '/termPage/medicalInquirieEdit',
                name: '在线问诊',
                component: () => import('@/views/termPage/medicalInquirie/medicalInquirieEdit.vue'),
            },
            {
                path: '/termPage/interaction',
                name: '患友互动',
                component: () => import('@/views/termPage/interaction/interaction.vue'),
            },
            {
                path: '/termPage/setTemplate',
                name: '模板消息',
                component: () => import('@/views/termPage/setTemplate/setTemplate.vue'),
            },
            {
                path: '/termPage/setTemplate/sendRecord',
                name: '发送记录',
                component: () => import('@/views/termPage/setTemplate/components/sendRecord/index.vue'),
            },
            {
                path: '/termPage/statistics',
                name: '数据统计',
                component: () => import('@/views/termPage/interaction/components/statistics/index.vue'),
            },
            {
                path: '/termPage/bannerConfig',
                name: '首页配置',
                component: () => import('@/views/termPage/bannerConfig/bannerConfig.vue'),
            },
            {
                path: '/flowreplay',
                name: '关注回复配置',
                component: () => import('@/views/CustomerService/flowreplay.vue'),
            },
            {
                meta: {
                    name: '公众号菜单配置',
                    flag: true
                },
                path: '/publicmenu',
                name: '公众号菜单配置',
                component: () => import('@/views/CustomerService/publicmenu.vue'),
            },
            {
                path: '/termPage/channelManagement',
                name: '渠道管理',
                component: () => import('@/views/termPage/channelManagement.vue'),
            },
            {
              path: '/termPage/cooperateChannelManage',
              name: '合作渠道管理',
              component: () => import('@/views/termPage/cooperateChannelManage.vue'),
            },
            {
                path: '/termPage/addCooperateChannel',
                name: '新增渠道机构',
                component: () => import('@/views/termPage/addCooperateChannel.vue'),
            },
            {
                path: '/termPage/cardPwd',
                name: '/termPage/cardPwd',
                component: () => import('@/views/termPage/cardPwd.vue'),
            },
            {
              path: '/termPage/addCardPwd',
              name: '卡密新增',
              component: () => import('@/views/termPage/addCardPwd.vue'),
            },
            {
                path: '/termPage/cardPwdRecord',
                name: '使用记录',
                component: () => import('@/views/termPage/cardPwdRecord.vue'),
            },
            {
                path: '/termPage/operationalMessage',
                name: '运营消息',
                component: () => import('@/views/termPage/operationalMessage/operationalMessage.vue'),
            },
            {
                path: '/termPage/operationalMessageRecord',
                name: '查看记录',
                component: () => import('@/views/termPage/operationalMessage/operationalMessageRecord.vue'),
            },
            {
                path: '/termPage/operationalMessageAddEdit',
                name: '新增运营消息',
                component: () => import('@/views/termPage/operationalMessage/operationalMessageAddEdit.vue'),
            },
            {
                path: '/termPage/userSet',
                name: '查看记录',
                component: () => import('@/views/termPage/userSet/userSet.vue'),
            }
            // {
            //     path: '/termPage/landPage',
            //     name: '落地页配置',
            //     component: () => import('@/views/termPage/landPage/landPage.vue'),
            // },
            // {
            //     path: '/termPage/landPageList',
            //     name: '落地页配置列表',
            //     component: () => import('@/views/termPage/landPage/landPageList.vue'),
            // }
        ]
    },
    {
        path: '/operationPromote',
        name: '运营推广',
        component: ContainerView,
        children: [
            {
                path: '/operationPromote/landPage',
                name: '落地页配置',
                component: () => import('@/views/termPage/landPage/landPage.vue'),
            },
            {
                path: '/operationPromote/landPageList',
                name: '落地页配置列表',
                component: () => import('@/views/termPage/landPage/landPageList.vue'),
            }
        ]
    },
    {
        path: '/readReport',
        name: '报告解读',
        component: ContainerView,
        children: [
            {
                path: '/readReport/view',
                name: '报告解读管理',
                component: () => import('@/views/readReport/index.vue'),
            },
        ]
    },
    {
        path: '/pushManagement',
        name: '推送管理',
        component: ContainerView,
        children: [
            {
                path: '/pushManagement/view',
                name: '计划管理',
                component: () => import('@/views/pushManagement/index.vue'),
            },
            {
                path: '/pushManagement/component/addPlan',
                name: '新增计划',
                component: () => import('@/views/pushManagement/component/addPlan/index.vue'),
            },
            {
                path: '/pushManagement/component/pushPackage',
                name: '推送服务包管理',
                component: () => import('@/views/pushManagement/component/pushPackage/index.vue'),
            },
        ]
    },
    {
        path: '/CommodityManagement',
        name: '商品管理',
        component: ContainerView,
        children: [
            {
                path: '/CommodityManagement/CommodityManagementList',
                name: 'CommodityManagement',
                component: () => import('@/views/CommodityManagement/src/CommodityManagementList/index.vue'),
            },
            {
                path: '/CommodityManagement/CommodityManagementList/addCommodity',
                name: '新增商品',
                component: () => import('@/views/CommodityManagement/src/CommodityManagementList/addCommodity.vue'),
            },
        ]
    },
    {
      name: '协同管理',
      path: '/cooperateWithManage',
      component: ContainerView,
      children: [
          {
              name: 'consultationCooperate',
              path: '/cooperateWithManage/consultationCooperate',
              component: () => import('@/views/cooperateWithManage/consultationCooperate.vue'),
              meta: {
                  title: '协同记录',
              },
          },
          {
            name: 'cooperativeRelationship',
            path: '/cooperateWithManage/cooperativeRelationship',
            component: () => import('@/views/cooperateWithManage/cooperativeRelationship.vue'),
            meta: {
                title: '协同关系配置',
            },
          },
          {
            name: 'createConsultation',
            path: '/cooperateWithManage/createConsultation',
            component: () => import('@/views/cooperateWithManage/createConsultation.vue'),
            meta: {
                title: '创建会诊',
            },
          }
      ]
  },
  {
    path: '/EventManagement',
    name: '事件管理',
    component: ContainerView,
    children: [
        {
            path: '/EventManagement/EventManagementList',
            name: '事件列表',
            component: () => import('@/views/EventManagement/EventManagementList.vue'),
        },
    ]
  },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.flag) {
        let head = document.getElementsByTagName("head")
        let meta = document.createElement("meta")
        meta.name = 'referrer'
        meta.content = 'never'
        head[0].appendChild(meta)
    } else {
        let head = document.getElementsByTagName("head")
        let meta = document.createElement("meta")
        meta.name = 'viewport'
        meta.content = 'width=device-width,initial-scale=1.0'
        head[0].appendChild(meta)
    }
    NProgress.start();
    next();
});
router.afterEach(() => {
    NProgress.done();
});
export default router
